import React from 'react'
import { DisputeTypeData } from './DisputeTypeData'
import { useParams } from 'react-router-dom'
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';

const DisputeTypeDetailPage = () => {
  const {disputeCode} = useParams();
  const empDetail = DisputeTypeData.find((emp)=>emp.disputeCode===disputeCode)
  console.log(empDetail)
   const breadcrumbItems = [{ title: "Back To Dispute Type List", link: "/dispute" }];
  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb
          pageTitle="Dispute Type"
          title="Dispute Type Detail"
          breadcrumbItems={breadcrumbItems}
        />
      </div>
      <Card
        className=" p-4 shadow-sm border-0 w-100"
        style={{ backgroundColor: "#f9f9f9" }}
      >
        <Row className="mb-4">
      
          <Col lg={12} className="d-none d-lg-block">
            <div
              className="vr"
              style={{ height: "100%", backgroundColor: "#ccc" }}
            />
          </Col>

          <Col lg={7} xs={12}>
            {/* <h6 className="fs-4 fw-bold mb-2" style={{ color: "#333" }}>
                    {userData?.username}
                  </h6> */}

            {/* <hr /> */}
            <h6 className="fs-4 fw-bold mb-2" style={{ color: "#333" }}>
              {empDetail?.disputeName}
            </h6>
            <hr />
            <h6 className="fs-6 fw-bold mb-1">
              <i className="fas fa-envelope me-2"></i>
              {/* Email: {userData?.email} */}
              Dispute Code: {empDetail?.disputeCode || "N/A"}
            </h6>
            <hr />

            <h6 className="fs-6 fw-bold mb-1" >

            <p className="fas fa-phone me-2 ps-2">Dispute Description : 
              {empDetail?.description || "Invalid number"}</p>
            </h6>
             <hr />
             <h6 className="fs-6 fw-bold mb-1">
              <i className="fas fa-phone me-2"></i>
              Dispute Assigned By : {empDetail?.createdBy || "Invalid number"}
            </h6>
             <hr />
           
          

          </Col>
        </Row>
      </Card>
      <Row>
        {/* Database Info */}
        <Col md={4}>
          <Card className="mb-4 shadow-sm">
            <CardBody>
              <h3 className="h4 mb-3">{empDetail?.disputeName}</h3>
             
            </CardBody>
          </Card>
        </Col>

        {/* Tables Accordion */}
        <Col md={8}>
          <Card className="shadow-sm">
            <CardHeader className="border-0">
              <h5 className="mb-0">Dispute Description:</h5>
            </CardHeader>
            <CardBody>
              <p>{empDetail?.description}</p>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default DisputeTypeDetailPage
